import * as React from "react";

import { getId } from "@fluentui/react";
import { AppButtonState } from "../components/AppButton/next";
import { hiddenContentClassName } from "@1js/acui-common";

export type StateWithAriaDescriptionProperties = {
  root: {
    "aria-describedby"?: string;
    children?: AppButtonState["root"]["children"];
  };
};

export function useAriaDescription<
  T extends StateWithAriaDescriptionProperties
>(state: T, ariaDescription?: string) {
  // Create a unique ID for the span that won't change later
  // Needs to be run unconditionally since it's a hook
  // ADO 5866409: this uses Fluent v8's getId
  const uniqueID = React.useRef(getId()).current;
  if (ariaDescription) {
    // Prepend the ID to the aria-describedby attribute on the root button
    const ariaDescribedBy = state.root["aria-describedby"] || "";
    state.root["aria-describedby"] = uniqueID + " " + ariaDescribedBy;
    // Add the span with the description to the existing children, if any
    const children = state.root.children ? [state.root.children] : [];
    children.push(
      <span className={hiddenContentClassName} id={uniqueID}>
        {ariaDescription}
      </span>
    );
    state.root.children = <>{children}</>;
  }
}
